<script setup lang="ts">
import { useAuthStore } from '@stores/auth'
import { useGlobalStore } from '@stores/global'
import { ref } from 'vue'

import Button from '@components/global/button.vue'
import Input from '@components/global/input.vue'

const global = useGlobalStore()
const auth = useAuthStore()
const processing = ref(false)
const code = ref('')
const errors = ref({})

function submit(form) {
	form.preventDefault()
	if (!processing.value) {
		processing.value = true
		auth.submit2FA(code.value).catch((errorBag) => {
			processing.value = false
			errors.value = errorBag
		})
	}
}
</script>
<template>
	<div class="modal-overlay" v-if="global.modal?.name === '2fa'">
		<div @click="$event.stopPropagation()" class="modal-content max-w-[25rem]">
			<div class="flex items-center justify-between p-4 uppercase">
				<i class="icon-logo text-4xl" />
				<span class="label-medium">Two Factor</span>
				<div class="w-8"></div>
			</div>
			<form class="flex w-full flex-col gap-6 rounded-max border border-border-default bg-neutral-700 p-4" action="" @submit="submit">
				<Input label="Auth Code" placeholder="Enter your 6-digit code" max="21" :required="true" v-model="code" :error="(errors.code && errors.code[0]) || (errors.recovery_code && errors.recovery_code[0])" />
				<Button class="default" :processing="processing" :disabled="code.length < 6">submit</Button>
				<span class="label-medium self-center text-center">
					Issues signing in? Reach out to
					<a class="text-purple-base" href="mailto:support@ether.site">support@ether.site</a>
				</span>
				<img class="w-full" alt="im" src="https://cdn.ether.site/images/long-dots.svg" />
			</form>
		</div>
	</div>
</template>
